import React, { Component } from "react";
import {
    View, Image, TouchableOpacity,
    TouchableWithoutFeedback,
    FlatList, Platform, Dimensions
} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, customerLocationStyles } from '../theme/styles'
import TextView from "../components/TextView";
import CedarMaps from '@cedarstudios/react-cedarmaps';

const { width } = Dimensions.get('window');

const LATITUDE = 35.724566;
const LONGITUDE = 51.367788;

import Button from "../components/Button";
import { myAddresBooksRequest, findAddressRequest, searchAddressRequest } from "../utils/api";
import { wp, hp } from "../utils/responsive";
import EditText from "../components/EditText";
import Waiting from "../components/Waiting";
import { darkColor } from "../theme/colors";
const styles = {
    icon: {
        iconImage: icons['onmappin'],
        iconSize: 0.3,
        iconOffset: [0, -20],
        iconAllowOverlap: false,
    },
};
var geojson = {
    type: 'FeatureCollection',
    features: [{
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [51.367788, 35.724566]
        },
        properties: {
            title: 'موقعیت انتخابی',
            description: ''
        }
    }]
};

export default class CustomerLocationScreen extends Component {

    constructor(props) {
        super(props)

        this.state = {

            coordinates: [[-73.99155, 40.73581]],

            favorits: [{
                id: 0,
                icon: 'plus',
                nameaddress: 'افزودن آدرس منتخب'
            }],
            featureCollection: null,
            infoCity: null,
            zoomLevel: 15,
            latitude: 0,
            longitude: 0,
            showAddress: false,
            addresses: [],
            center: [LONGITUDE, LATITUDE],
            currentCenter: [LONGITUDE, LATITUDE],
            currentGeo: null,
            region: null,
            address: '',
            search: '',
            waiting: true,
            ready: false,
        }

    }
    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <TouchableOpacity
            style={{
                backgroundColor: '#eeeeeecc',
                borderRadius: 8,
                marginLeft: 10,
                marginTop: 5,
                marginRight: 20, padding: 10
            }} onPress={() => {
                var location = item.location.center.split(',');
                this.setState({
                    showAddress: false,
                    center: [parseFloat(location[1]), parseFloat(location[0])],
                    currentCenter: [parseFloat(location[1]), parseFloat(location[0])]
                })
            }}>
            <TextView style={{ textAlign: 'right' }}>{item.name}</TextView>
            <TextView style={{ textAlign: 'right', marginTop: 5, color: 'gray' }}>{item.address}</TextView>
        </TouchableOpacity>
    }
    renderFavoritRow({ item, index }) {
        return <TouchableOpacity style={componentStyles.favoritItem} activeOpacity={0.5} onPress={() => {
            if (item.id == 0) {
                this.props.navigation.navigate('createAddressBook', {
                    id: 0,
                    refresh: () => {
                        this.getAddress()
                    }
                })
            } else {
                this.props.navigation.navigate('fillAddress', {
                    addressId: item.id,
                    nameaddress: item.nameaddress,
                    address: item.address,
                })
            }

        }}>
            <TextView>{item.nameaddress}</TextView>
            <Image source={icons[item.icon ? item.icon : 'pin']} style={[componentStyles.favoritIcon, { tintColor: item.icon ? darkColor : '#FFEA00' }]} />
        </TouchableOpacity>
    }

    setCenterMap(latlng)
    {
        this.setState({
            currentCenter: latlng
        })
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={[appStyles.toolbarWraper,{backgroundColor:'white'}]}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <View style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center', width: wp(75)
                }}>
                    <TouchableOpacity onPress={() => {
                        this.setState({
                            showAddress: true
                        })

                    }}>
                        <Image source={icons['search']} style={{ width: 25, margin: 5, height: 25, resizeMode: 'contain' }} />
                    </TouchableOpacity>
                    <TouchableOpacity style={[appStyles.textInput, { width: wp(60), borderWidth: 0, borderBottomWidth: 1 }]} onPress={() => {
                        this.setState({
                            showAddress: true
                        })
                    }}>
                        <TextView style={{ color: 'gray', textAlign: 'center', width: wp(60) }}>محل مورد نظرتان کجاست؟</TextView>
                    </TouchableOpacity>


                </View>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <View style={{ height: hp(7), margin: hp(2),backgroundColor:'white' }}>
                <FlatList
                    data={this.state.favorits}
                    showsHorizontalScrollIndicator={false}
                    renderItem={this.renderFavoritRow.bind(this)}
                    keyExtractor={this._keyExtractor}
                    horizontal={true}
                />
            </View>

            <CedarMaps
                logoPosition='top-left'
                containerStyle={{
                    height: '100vh',
                    width: '100%'
                }}
                onMoveEnd={(_, event) => {
                    console.log(event)
                    if (event.target._easeOptions.center != null) {
                        if (Array.isArray(event.target._easeOptions.center)) {
                            this.findAddress(event.target._easeOptions.center[1], event.target._easeOptions.center[0])
                            this.setCenterMap(event.target._easeOptions.center)
                        } else {
                            this.findAddress(event.target._easeOptions.center.lat, event.target._easeOptions.center.lng)
                            this.setCenterMap([event.target._easeOptions.center.lng, event.target._easeOptions.center.lat])
                        }
                    }else if (event.target._easeOptions.around != null) {
                        if (Array.isArray(event.target._easeOptions.around)) {
                            this.findAddress(event.target._easeOptions.around[1], event.target._easeOptions.around[0])
                            this.setCenterMap(event.target._easeOptions.around)
                        } else {
                            this.findAddress(event.target._easeOptions.around.lat, event.target._easeOptions.around.lng)
                            this.setCenterMap([event.target._easeOptions.around.lng, event.target._easeOptions.around.lat])
                        }
                    } else if (event.lngLat != null) {
                        this.findAddress(event.lngLat.lat, event.lngLat.lng)
                        this.setCenterMap([event.lngLat.lng, event.lngLat.lat])
                    }


                }}
                token='de1f4bf85b1e70f435a36cc27a5a61075793a194'
                center={this.state.center}
            >
            </CedarMaps>
            <TouchableOpacity style={{ backgroundColor: 'white', borderRadius: 5, position: 'absolute', right: 5, bottom: 180 }} onPress={() => {
                this.getCurrentPosition();
            }}>
                <Image source={icons['target']} style={appStyles.toolbarIcon} />
            </TouchableOpacity>
            {this.state.region == null ?
                <TouchableOpacity style={{ position: 'absolute', alignSelf: 'center', top: hp(100) / 2 }} onPress={() => {
                    this.onPointClick()
                }}>
                    <Image source={icons['onmappin']} style={{ width: wp(20), height: wp(20), resizeMode: 'contain' }} />
                </TouchableOpacity> : <View />}


            <View style={[appStyles.bottomView, appStyles.center]}>
                <TextView numberOfLines={3} style={customerLocationStyles.address}>آدرس مددجو : {this.state.address}</TextView>
                <Button
                    style={customerLocationStyles.button}
                    text='تایید آدرس و ادامه'
                    textStyle={customerLocationStyles.buttonText}
                    showArrow={true}
                    onPress={() => {
                        this.onPointClick()
                    }}
                />
            </View>
            {this.state.showAddress&&<TouchableWithoutFeedback onPress={() => {
                    this.setState({
                        showAddress: false
                    })

                }}>
                    <View style={appStyles.modalMessageAbsolute} >
                        <TouchableWithoutFeedback onPress={() => {
                        }}>
                            <View style={appStyles.modalSearchContent}>
                                <View style={[appStyles.toolbarWraper, { borderBottomColor: '#eeeeee', borderBottomWidth: 1 }]}>
                                    <View style={appStyles.backIcon} />
                                    <TextView>محل مورد نظرتان کجاست؟</TextView>

                                    <TouchableOpacity onPress={() => {
                                        this.setState({
                                            showAddress: false
                                        })
                                    }}>
                                        <Image source={icons['back']} style={appStyles.backIcon} />
                                    </TouchableOpacity>
                                </View>
                                <EditText
                                    hint='مثل جردن ، نمایشگاه و ...'
                                    textStyle={{ color: 'black', width: wp(90) }}
                                    style={[appStyles.textInput, { width: wp(90), borderWidth: 0, borderBottomWidth: 1, borderColor: '' }]}
                                    onChangeText={(text) => {
                                        this.setState({
                                            search: text
                                        }, () => {
                                            if (this.state.search.length > 0) {
                                                this.setState({
                                                    waiting: true
                                                })
                                                var lat = this.state.currentCenter[1];
                                                var lng = this.state.currentCenter[0];
                                                searchAddressRequest(this.state.search, lat, lng, (isConnect, response) => {
                                                    this.setState({
                                                        waiting: false
                                                    })
                                                    if (isConnect) {
                                                        this.setState({
                                                            showAddress: true,
                                                            addresses: response.results
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }}
                                    value={this.state.search}
                                />
                                <FlatList
                                    data={this.state.addresses}
                                    refreshing={this.state.waiting}
                                    onRefresh={() => {

                                    }}
                                    keyboardShouldPersistTaps='handled'
                                    style={{ width: width }}
                                    keyExtractor={this._keyExtractor}
                                    renderItem={this.renderRow.bind(this)}
                                />
                            </View>
                        </TouchableWithoutFeedback>
                    </View>
                </TouchableWithoutFeedback>}
            <Waiting waiting={this.state.waiting} />
        </View>)
    }
    onSourceLayerPress(e) {
        const feature = e.nativeEvent.payload;
        console.log('You pressed a layer here is your feature', feature); // eslint-disable-line
    }
    onPointClick() {
        this.setState({
            waiting: true
        })
        var lat = this.state.currentCenter[1];
        var lng = this.state.currentCenter[0];
        findAddressRequest(lat, lng, (isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    latitude: lat,
                    infoCity: !Array.isArray(response.data.infocity) ? response.data.infocity : null,
                    address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                    longitude: lng,

                }, () => {
                    this.props.navigation.navigate('fillAddress', {
                        addressId: 0,
                        latitude: lat,
                        address: this.state.address,
                        longitude: lng,
                        infoCity: this.state.infoCity
                    })
                });

            }
        })

    }
    findAddress(lat, lng) {
        findAddressRequest(lat, lng, (isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    latitude: lat,
                    infoCity: !Array.isArray(response.data.infocity) ? response.data.infocity : null,
                    address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                    longitude: lng,
                });
            }
        })
    }

    onPress(event) {
        if (this.state.region != null) {


            const { geometry, properties } = event;
            var lat = geometry.coordinates[1];
            var lng = geometry.coordinates[0];
            var currentGeo = geojson;
            currentGeo.features[0].geometry.coordinates = geometry.coordinates;
            this.setState({
                waiting: true,
                currentCenter: [lng, lat],
                currentGeo: currentGeo,
                region: [lng, lat],
                zoomLevel: this.state.zoomLevel,
                center: [lng, lat],
            })

            findAddressRequest(lat, lng, (isConnect, response) => {
                this.setState({
                    waiting: false
                })
                if (isConnect && response.isSuccess) {
                    this.setState({
                        latitude: lat,
                        infoCity: !Array.isArray(response.data.infocity) ? response.data.infocity : null,
                        address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                        longitude: lng,

                    });
                }
            })
        }

    }
    getAddress() {
        myAddresBooksRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                var favorits = [...this.state.favorits, ...response.data];

                console.log(favorits)
                this.setState({
                    favorits: favorits
                })
            }
        })
    }
    componentWillMount() {
        this.getAddress()

            this.getCurrentPosition()


    }

    getCurrentPosition() {

            try {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        console.log([position.coords.longitude, position.coords.latitude])
                        this.setState({
                            center: [position.coords.longitude, position.coords.latitude],
                            currentCenter: [position.coords.longitude, position.coords.latitude],
                            zoomLevel: 15,
                        })

                        findAddressRequest(position.coords.latitude, position.coords.longitude, (isConnect, response) => {
                            this.setState({
                                waiting: false
                            })
                            if (isConnect && response.isSuccess) {
                                this.setState({
                                    // region: [position.coords.longitude, position.coords.latitude],
                                    // center: [position.coords.longitude, position.coords.latitude],
                                    // currentCenter: [position.coords.longitude, position.coords.latitude],
                                    latitude: position.coords.latitude,
                                    address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                                    longitude: position.coords.longitude,
                                });
                            }
                        })


                    },
                    (error) => {
                        this.setState({
                            waiting: false,
                        })
                        console.log(error)
                        switch (error.code) {
                            case 1:
                                if (Platform.OS === "ios") {
                                    alert("برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - حریم خصوصی - موقعیت مکانی را فعال کنید");
                                } else {
                                   alert( "برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - Apps - AsanDarman - Location را فعال کنید");
                                }
                                break;
                            default:
                                alert( "خطا در تشخیص موقعیت مکانی ! لطفا مجددا سعی نمایید");
                        }
                    }, { enableHighAccuracy: true, timeout: 30000, maximumAge: 30000 }
                );
            } catch (e) {
                alert(e.message || "");
            }




    };

}
